export default "__VITE_ASSET__D_mwpF9Z__"